export default __webpack_public_path__ + "static/media/colombia.74c01aaa.svg";